import React from "react";
import { Link as RouterLink } from "react-router-dom"; // For internal navigation
import "./Footer.css"; // We'll create/update this
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import VereinsLogoLight from "../../Assets/logo.png"; // Replace with your light logo path
import TennisLogo from "../../Assets/tennislogo.png"; // Path to the tennis logo

function Footer() {
  const scrollToSection = (id) => {
    // Check if on homepage, otherwise navigate to homepage then scroll
    if (window.location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      // For simplicity, this example navigates and relies on ScrollToTop.
      // A more advanced solution would pass a hash to the homepage.
      window.location.href = `/#${id}`;
    }
  };

  return (
    <footer className="footer-reworked">
      <div className="container">
        <div className="footer-content">
          {/* Column 1: Brand/Logo and About */}
          <div className="footer-column footer-brand-info">
            <img src={VereinsLogoLight} alt="VfB Johannesberg Logo" className="footer-logo" />
            <p className="footer-tagline">
              Sport, Gemeinschaft und Leidenschaft – seit 1984.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-column footer-links-section">
            <h5 className="footer-heading">Navigation</h5>
            <ul className="footer-nav">
              <li>
                <RouterLink to="/" className="footer-nav-link">Homepage</RouterLink>
              </li>
              <li>
                <RouterLink to="/about-us" className="footer-nav-link">Über uns</RouterLink>
              </li>
              <li>
                <RouterLink to="/contact" className="footer-nav-link">Kontakt</RouterLink>
              </li>
              <li>
                <RouterLink to="/impressum" className="footer-nav-link">Impressum</RouterLink>
              </li>
              <li>
                <RouterLink to="/datenschutz" className="footer-nav-link">Datenschutz</RouterLink>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact Information */}
          <div className="footer-column footer-contact-info">
            <h5 className="footer-heading">Kontakt</h5>
            <ul className="contact-list">
              <li className="contact-item">
                <FaEnvelope className="contact-icon" />
                <a href="mailto:vfb-johannesberg@web.de">vfb-johannesberg@web.de</a>
              </li>
              <li className="contact-item">
                <FaPhone className="contact-icon" />
                <a href="tel:+491717924528">0171-7924528</a>
              </li>
              <li className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Douglasienweg 2, 36251 Bad Hersfeld</span>
              </li>
            </ul>
          </div>

           {/* Column 4: Social Media (Optional) */}
           <div className="footer-column footer-social-media">
            <h5 className="footer-heading">Folge Uns</h5>
            <div className="social-links">
              <a href="https://www.facebook.com/groups/635775240268652/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook className="social-icon" />
              </a>
              <a href="https://www.instagram.com/vfbjohannesberg/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram className="social-icon" />
              </a>
            </div>
          </div>

         
        </div>

        <div className="footer-bottom-reworked">
          <p>© {new Date().getFullYear()} VfB Johannesberg. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;